export class AuthToken {
   token: string;
   token_link: number;
}